// extracted by mini-css-extract-plugin
export var root = "PlasmicFooter-module--root--1nSxp";
export var box__tbFir = "PlasmicFooter-module--box__tbFir--1PC6D";
export var box__zvT9 = "PlasmicFooter-module--box__zvT9--34wMt";
export var box___7OA3D = "PlasmicFooter-module--box___7OA3D--3xmQT";
export var link = "PlasmicFooter-module--link--18Qyi";